export enum ConveyanceType {
  Buy = 'buy',
  Rent = 'rent',
}
